module.exports = __webpack_public_path__ + "static/img/dy.42bfe1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dy.png
// module id = ZNXt
// module chunks = 3